import React from "react";

export default function Summary({ data }) {
  const guestTotals = {};
  data.guests.forEach((g) => (guestTotals[g] = 0));

  data.meals.forEach((meal) => {
    const assigned = meal.assigned ?? [];

    const totalShares = assigned.reduce((sum, a) => sum + (a.share ?? 1), 0);

    assigned.forEach(({ guest, share }) => {
      const effectiveShare = share ?? 1;
      const portion = (meal.price * effectiveShare) / totalShares;
      guestTotals[guest] += portion;
    });
  });

  // Add SST (if any)
  const subtotal = Object.values(guestTotals).reduce((a, b) => a + b, 0);
  if (data.sst && subtotal > 0) {
    const sst = parseFloat(data.sst);
    Object.keys(guestTotals).forEach((g) => {
      const ratio = guestTotals[g] / subtotal;
      guestTotals[g] += sst * ratio;
    });
  }

  return (
    <div style={{ maxWidth: "500px", margin: "0 auto", padding: "1rem" }}>
      <h2>Summary</h2>

      {/* Meals List
      <h3>Meals</h3>
      <ul>
        {data.meals.map((meal, i) => (
          <li key={i}>
            {meal.name} (RM {meal.price.toFixed(2)}) – Assigned to:{" "}
            {meal.assigned?.map((a) => a.guest).join(", ") || "None"}
          </li>
        ))}
      </ul> */}

      {/* Guest Cards */}
      <h3>Guest Breakdown</h3>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {data.guests.map((guest, i) => {
          const assignedMeals = data.meals.filter((meal) =>
            meal.assigned?.some((a) => a.guest === guest)
          );

          return (
            <div
              key={i}
              style={{
                backgroundColor: "#E6E6FA", // lavender
                borderRadius: "12px",
                padding: "1rem",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              {/* Guest Name */}
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginBottom: "0.5rem",
                }}
              >
                {guest}
              </div>

              {/* Assigned Meals and Prices */}
              <div style={{ fontSize: "12px", marginBottom: "0.5rem" }}>
                {assignedMeals.map((meal, mIndex) => {
                  const guestEntry = meal.assigned?.find(
                    (a) => a.guest === guest
                  );
                  const guestShare = guestEntry?.share ?? 1;

                  const totalShares =
                    meal.assigned?.reduce(
                      (sum, a) => sum + (a.share ?? 1),
                      0
                    ) || 1;

                  const amount = (meal.price * guestShare) / totalShares;

                  return (
                    <div
                      key={mIndex}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "0.25rem",
                      }}
                    >
                      <span>{meal.name}</span>
                      <span>RM {amount.toFixed(2)}</span>
                    </div>
                  );
                })}
              </div>

              {/* Guest Total */}
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  textAlign: "right",
                  borderTop: "1px solid #ccc",
                  paddingTop: "0.5rem",
                }}
              >
                Total: RM {guestTotals[guest]?.toFixed(2) || "0.00"}
              </div>
            </div>
          );
        })}
      </div>

      {/* Final Summary */}
      <h3>Summary</h3>
      <p>Subtotal: RM {subtotal.toFixed(2)}</p>
      <p>SST: RM {parseFloat(data.sst || 0).toFixed(2)}</p>
      <p>Total: RM {(subtotal + parseFloat(data.sst || 0)).toFixed(2)}</p>
    </div>
  );
}
